import { render, staticRenderFns } from "./myOnboardingComponent.vue?vue&type=template&id=0d04117e"
import script from "./myOnboardingComponent.vue?vue&type=script&lang=js"
export * from "./myOnboardingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports